const transitionTime = 500; // time is in ms

export default transitionTime